var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSaveFloppyDisk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 19V5C3 4.46957 3.21071 3.96086 3.58579 3.58579C3.96086 3.21071 4.46957 3 5 3H16.172C16.7024 3.00011 17.211 3.2109 17.586 3.586L20.414 6.414C20.7891 6.78899 20.9999 7.29761 21 7.828V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.6 9H15.4C15.5591 9 15.7117 8.93679 15.8243 8.82426C15.9368 8.71174 16 8.55913 16 8.4V3.6C16 3.44087 15.9368 3.28826 15.8243 3.17574C15.7117 3.06321 15.5591 3 15.4 3H8.6C8.44087 3 8.28826 3.06321 8.17574 3.17574C8.06321 3.28826 8 3.44087 8 3.6V8.4C8 8.55913 8.06321 8.71174 8.17574 8.82426C8.28826 8.93679 8.44087 9 8.6 9V9ZM6 13.6V21H18V13.6C18 13.4409 17.9368 13.2883 17.8243 13.1757C17.7117 13.0632 17.5591 13 17.4 13H6.6C6.44087 13 6.28826 13.0632 6.17574 13.1757C6.06321 13.2883 6 13.4409 6 13.6V13.6Z",
    stroke: "white",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSaveFloppyDisk);
export default __webpack_public_path__ + "static/media/ic_save_floppy_disk.9b6d4a8b6ba8f3eb2b62f334ccf235d9.svg";
export { ForwardRef as ReactComponent };